<template>
  <el-popover
    placement="bottom"
    :width="240"
    trigger="hover"
    :show-arrow="false"
    :popper-class="['c-header-popper', 'header-download-popper', theme || injectTheme || routeTheme]"
  >
    <template #reference>
      <!-- 头部下载按钮 -->
      <span class="header-down cursor-pointer" :class="$attrs.class" />
      <!-- <img
        class="download cursor-pointer"
        src="@/assets/img/svg/icon-download.svg"
        alt="download"
      > -->
    </template>

    <div class="qrcode text-1">
      <div class="text-align-center weight-600 fz14 lh22">
        {{ $t("扫码下载") }}
      </div>
      <img
        :src="qrcode"
        width="200"
        class="mt8"
      >
      <i class="qr-logo" />
      <router-link to="/download">
        <el-button
          style="width:100%;height: 40px;"
          type="primary"
          class="weight-500 fz16 mt14 more-btn"
          @click="eventTrack({ name: 'web_click_home_downloadmore' })"
        >
          {{ $t('更多') }}
        </el-button>
      </router-link>
    </div>
  </el-popover>
</template>

<script setup lang="ts">
import { inject } from 'vue';
import { useCommonStore } from '@/store/common';
import { useQRCode } from '@vueuse/integrations/useQRCode';
import { envOrigin } from '@/config/setup';
import eventTrack from '@/utils/eventTracking';

const route = useRoute();

defineProps({
  theme: {
    type: String,
    default: ''
  }
});

const injectTheme = inject('theme');

const comm = useCommonStore();
const qrcode:any = useQRCode(`${envOrigin}/${comm.lang}/download`, {
  margin: 1
});

const routeTheme = computed(() => {
  const routeProps: any = route.meta.props;

  return routeProps?.header?.theme;
});
</script>

<style lang="scss" scoped>
.qrcode {
  position: relative;
  padding: 16px 20px;

  img {
    border-radius: 4px;
  }
}

.qr-logo {
  display: inline-block;
  position: absolute;
  top: 127px;
  left: 50%;
  width: 38px;
  height: 38px;
  margin-left: -21px;
  background: url(@/assets/img/hk-header/download-qrcode.svg) center/100% 100% no-repeat;
}

.header-down {
  width: 28px;
  height: 28px;
  background: url(@/assets/img/hk-header/icon-download-light.svg) center/20px 20px no-repeat;

  // &:hover {
  //   background: url(@/assets/img/svg/icon-download-hover-light.svg) center/20px 20px no-repeat;
  // }
}

.dark {
  .header-down {
    background: url(@/assets/img/hk-header/icon-download-dark.svg) center/20px 20px no-repeat;

    // &:hover {
    //   background: url(@/assets/img/svg/icon-download-hover-dark.svg) 0 0/100% 100% no-repeat;
    // }
  }
  .more-btn {
    color: var(--gray-700);
    background: var(--gray-100);
    box-shadow: 0 1px 2px 0 rgba(16, 24, 40, 0.05);
    &:hover {
      background: var(--gray-50);
    }
  }
}
</style>
